import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-attachment-url"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "link-dashed" }
const _hoisted_8 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_9 = ["src"]

import {computed, inject, onBeforeUnmount, ref} from 'vue';
import CoreUiHtmlify from "~/core-ui/vue/ui/CoreUiHtmlify.vue";
import AudioPlayButton from "~/cabinet/vue/interface/data/AudioPlayButton.vue";
import OnlineMessageFileContentDescription from "~/core-ui/vue/chat/content/OnlineMessageFileContentDescription.vue";
import {internationalUrlIfNeeded} from "~/core-ui/ts/Constants";
import {LightboxInjection} from "~/core-ui/ts/LightboxInjection";
import CoreUiHtmlifySnippetEventInterface from "~/core-ui/vue/ui/CoreUiHtmlifySnippetEventInterface";
import {CoreUiChatHistoryActionsInterface} from "~/core-ui/vue/chat/CoreUiChatHistoryActions";
import {__} from "~/ts/library/Translate";
import {
    CURRENT_DIALOGS_AUDIO_INJECTION_KEY
} from "~/operatorApplication/vue/dialogs/OperatorApplicationDialogsInjection";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import LanguagePopover from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/LanguagePopover.vue";
import {SNIPPET_DISPLAY_SIZE} from "~/operatorApplication/vue/misc/Snippet";
import {getSnippetImageStyle} from "~/core-ui/vue/ui/getSnippetImageStyle";


const __default__ = {
    name: "OnlineMessageFileContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    messageId: {},
    attachment: {},
    messageActions: {},
    htmlify: {}
  },
  emits: ["height-change"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

const AUDIO_SPEED_LIST = [0.5, 0.7, 1, 1.2, 1.5, 1.7, 2];

let audioSpeed = ref(1);
let transcribeModel = ref(false);

let currentDialogAudio = inject(CURRENT_DIALOGS_AUDIO_INJECTION_KEY, computed(() => null));


let audioElement = computed<HTMLAudioElement>(() => {
    if (currentDialogAudio.value && currentDialogAudio.value?.src == props.attachment.url) {
        return currentDialogAudio.value;
    }
    return null;
})
if (audioElement.value) {
    audioSpeed.value = currentDialogAudio.value.playbackRate;
}

let imagePreview = ref<string>();
let imagePreviewStyle = ref<string>();

let lightbox = inject(LightboxInjection, src => {
    if (src) {
        window.open(src);
    }
});

onBeforeUnmount(() => {
    lightbox(null);
});

function onSnippet(payload: CoreUiHtmlifySnippetEventInterface) {
    imagePreview.value = payload.snippet.type == "image" ? internationalUrlIfNeeded(payload.snippet.snipurl) : null;
    imagePreviewStyle.value = getSnippetImageStyle(payload.snippet, SNIPPET_DISPLAY_SIZE);
}

function onLinkClick(e: MouseEvent) {
    if (isImage.value) {
        lightbox(url.value);
    } else if (props.messageActions?.download) {
        e.preventDefault();
        e.stopPropagation();
        props.messageActions.download({
            attachment: props.attachment
        })
    }
}

let htmlifyComponent = computed(() => {
    return props.htmlify ? props.htmlify : CoreUiHtmlify;
});

function onHeightChange() {
    emits("height-change");
}

let url = computed(() => {
    return internationalUrlIfNeeded(props.attachment.url);
});

let isAudio = computed(() => {
    return props.attachment.type.id == "audio";
});

let isVideo = computed(() => {
    return props.attachment.type.id == "video";
});

let isImage = computed(() => {
    return props.attachment.type.id == "image";
});

function onAudioPlay(audio: HTMLAudioElement) {
    let method = props.messageActions?.onAudioPlay;
    if (method) {
        method(audio);
    }
}

function onAudioEnded(audio: HTMLAudioElement) {
    let method = props.messageActions?.onAudioEnded;
    if (method) {
        method(audio);
    }
}

let transcribeLanguageDescr = computed(() => {
    let result = props.attachment.audioTranscribe?.language;
    if (result && props.messageActions?.transcribe) {
        let language = props.messageActions.transcribe.getLanguages().find(lang => lang.id == result);
        if (language) {
            result = language.descr.toLowerCase();
        }
    }
    return result;
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: "attachment",
    "data-attachment-url": _unref(url)
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isAudio) || _unref(isVideo) || _unref(isImage) || (__props.messageActions && __props.messageActions.download) ? 'div' : 'a'), {
      href: _unref(url),
      onClick: onLinkClick,
      class: _normalizeClass({
                'cursor-pointer': !_unref(isAudio) && !_unref(isVideo)
            }),
      target: "_blank"
    }, {
      default: _withCtx(() => [
        (_unref(imagePreview))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(imagePreview),
              style: _normalizeStyle(_unref(imagePreviewStyle)),
              onLoad: onHeightChange
            }, null, 44, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_unref(isAudio))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(AudioPlayButton, {
                      "show-duration": "",
                      "audio-element": _unref(audioElement),
                      speed: _unref(audioSpeed),
                      src: _unref(url),
                      onPlay: onAudioPlay,
                      onEnded: onAudioEnded
                    }, {
                      default: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(OnlineMessageFileContentDescription, {
                            attachment: __props.attachment,
                            icon: slotProps.icon,
                            onIconClick: ($event: any) => (slotProps.onClick())
                          }, {
                            size: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "mr-2",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createVNode(_component_el_dropdown, {
                                  onCommand: _cache[0] || (_cache[0] = ($event: any) => (_isRef(audioSpeed) //@ts-ignore
 ? audioSpeed.value = $event : audioSpeed = $event)),
                                  trigger: "click"
                                }, {
                                  dropdown: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_menu, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(AUDIO_SPEED_LIST, (item) => {
                                          return _createVNode(_component_el_dropdown_item, {
                                            key: item,
                                            command: item
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item) + "x ", 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["command"])
                                        }), 64))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      class: "speed-button",
                                      plain: "",
                                      type: "info"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(audioSpeed)) + "x ", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              (slotProps.duration)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(slotProps.duration) + ", ", 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createElementVNode("a", {
                                target: "_blank",
                                href: _unref(url),
                                class: "download"
                              }, _toDisplayString(_unref(__)("Скачать")), 9, _hoisted_5)
                            ]),
                            _: 2
                          }, 1032, ["attachment", "icon", "onIconClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["audio-element", "speed", "src"]),
                    (__props.attachment.audioTranscribe)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (__props.attachment.audioTranscribe.text)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "mt-2 reply-to-message",
                                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(htmlifyComponent)), {
                                  value: __props.attachment.audioTranscribe.text
                                }, null, 8, ["value"])),
                                (__props.attachment.audioTranscribe.language)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                      _createTextVNode(_toDisplayString(_unref(__)("Язык")) + ": ", 1),
                                      (__props.messageActions?.transcribe && __props.messageId)
                                        ? (_openBlock(), _createBlock(LanguagePopover, {
                                            key: 0,
                                            modelValue: _unref(transcribeModel),
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(transcribeModel) ? (transcribeModel).value = $event : transcribeModel = $event)),
                                            languages: __props.messageActions.transcribe.getLanguages(),
                                            onSelect: _cache[3] || (_cache[3] = ($event: any) => (__props.messageActions.transcribe.addTask(__props.messageId, $event)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("a", _hoisted_7, _toDisplayString(_unref(transcribeLanguageDescr)), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "languages"]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(_unref(transcribeLanguageDescr)), 1)
                                          ], 64))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (__props.attachment.audioTranscribe.isWaiting)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(FontAwesomeIcon, {
                                  icon: "waveform-lines",
                                  class: "mr-1"
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(__)('Ожидание транскрибации...')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_unref(isVideo))
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 1,
                      onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                      controls: "",
                      src: _unref(url)
                    }, null, 8, _hoisted_9))
                  : (_openBlock(), _createBlock(OnlineMessageFileContentDescription, {
                      key: 2,
                      attachment: __props.attachment
                    }, null, 8, ["attachment"]))
            ]))
      ]),
      _: 1
    }, 8, ["href", "class"])),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(htmlifyComponent)), {
      class: "d-none",
      links: "",
      snippet: "",
      value: _unref(url),
      onSnippet: onSnippet
    }, null, 40, ["value"]))
  ], 8, _hoisted_1))
}
}

})